import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
  selector: '[leftResourceLayout]'
})
export class ResourceLeftLayoutDirective {

  constructor(public viewContainerRef: ViewContainerRef) {
  }

}
